<template>
    <div class="table">
    <h4>Detailed predictions&nbsp;<span class="howto">Use shift-click to sort on multiple columns, indicated by arrows and numbers. Use `true` or `false` to filter the two last columns</span></h4>
    <ag-grid-vue style="width: 100%; height: 100%;"
               class="ag-theme-alpine"
               :columnDefs="columnDefs"
               :rowData="rowData.value"
               :onGridReady="onGridReady"
               rowSelection="multiple"
               v-bind:rank=rank>
    </ag-grid-vue>
    </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import {reactive, onMounted, onGridReady} from "vue";
import TrueFalseRenderer from "@/components/widgets/TrueFalseRenderer.vue";
import PresenceRenderer from "@/components/widgets/PresenceRenderer.vue";

export default {
  name: 'Predictions',
  components: {
    AgGridVue,
    TrueFalseRenderer: TrueFalseRenderer,
    PresenceRenderer: PresenceRenderer
  },
  setup(props) {
    let rowData = reactive([]);
    rowData.value=[];
    onMounted(() => {
        fetch(`data/${props.sample}.json`)
          .then(result => result.json())
          .then(remoteRowData => {
            for (var idx in remoteRowData) {
              rowData.value.push(remoteRowData[idx]);
            }
        })
    });
    return {
        columnDefs: [
            { field: 'toolname', sortable: true, filter: 'agTextColumnFilter', headerName: 'Tool name' },
            { field: 'taxa', sortable: true, filter: 'agTextColumnFilter', headerName: 'Taxon', width: 300 },
            { field: 'rank', sortable: true, filter: 'agTextColumnFilter', headerName: 'Rank' },
            { field: 'reads', sortable: true, filter: 'agTextColumnFilter', headerName: 'Number of reads' },
            { field: 'abundance', sortable: true, filter: 'agTextColumnFilter', headerName: 'Relative abundance' },
            { field: 'correct_prediction', sortable: true, filter: 'agTextColumnFilter', headerName: 'Is correct?', cellRendererFramework: "TrueFalseRenderer" }
        ],
        onGridReady: (params) => {
            params.columnApi.applyColumnState({ state: [{colId: 'toolname', sort: 'asc', sortIndex: 0},
                                                 {colId: 'reads', sort: 'desc', sortIndex: 1}
                                                ] });
        },
        rowData
    };
  },
  props: {
    instance: String,
    sample: String,
    rank: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  margin:0;
  padding:0;
  background-color: #FFF;
  text-align:left;
  border:0;
  height:22em;
  color:black;
  text-align:left;
}
.table th {
  background-color:#F8FBFD;
  color:black;
  padding:1em;
  border-radius: 1em;
}
.table td {
  background-color:#F8F8F8;
  padding:0;
  margin:0;
}
.table tr {
  padding:0;
  margin:0;
  height:0;
}
.paragraph {
  font-size:0.9em;
  margin-bottom:0.9em;
  text-align:left;
}
h4 {
  padding:0;
  margin:0;
}
.howto {
    color:grey;
    font-size:0.66em;
}
</style>
